import Layout from "./src/components/Layout";
import LayoutLandingPage from "./src/components/LayoutLandingPage";
import { useStaticQueryDataChatMutuo } from "./src/query/useStaticQueryDataChatMutuo";
import "./src/sass/main.scss";
import {
  CHAT_MUTUO_HIDE_OLD_QUESTIONS,
  CHAT_MUTUO_IS_ACTIVE_LAST_CMS_MESSAGE,
  CHAT_MUTUO_IS_WIZARD_VISIBLE,
  CHAT_MUTUO_LATEST_CMS_MESSAGE,
  CHAT_MUTUO_SHOW_CURRENT_QUESTIONS,
  CHAT_MUTUO_SHOW,
  CHAT_MUTUO_SHOW_CHAT,
} from "./src/state/actions/chatmutuo.actions";
import {
  readChatNavPayload,
  clearChatNavPayload,
} from "./src/utils/backNavigation";
import {
  CHAT_MUTUO_SET_MESSAGES_CLIENT_ID,
  CHAT_MUTUO_SET_MESSAGES_UID,
  CHAT_MUTUO_IS_LAST_LINK_MESSAGES_VISIBILE, // CHAT_MUTUO_ADD_LAST_LINK_MESSAGES,
} from "./src/state/actions/chatmutuo.actions";
import {
  CONFIG_ADD_GCLID,
  CONFIG_ADD_MSMLID,
  CONFIG_ADD_QUERY_STRING_VALUES,
  CONFIG_ADD_UTMCHATBOT,
  CONFIG_ADD_LAST_METHOD_LID,
  CONFIG_ADD_UTMSOURCE,
  CONFIG_ADD_UTMCAMPAIGN,
  CONFIG_ADD_UTMMEDIUM,
  CONFIG_ADD_MSCLKID,
} from "./src/state/actions/config.actions";
import { getChatMutuo } from "./src/state/selectors/chatmutuo.selector";
import store from "./src/state/store";
import WebMcpTools from "./src/webmcp/WebMcpTools";
import { CHAT_MUTUO_FETCH_HISTORY } from "./src/state/thunk/chatmutuo.thunk";
import { FETCH_HISTORY } from "./src/state/thunk/history.thunk";
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { useSelector } from "react-redux";
import "swiper/css";
import "swiper/css/navigation";
import Cookies from "universal-cookie";

async function initialSetupConfigAppAsync() {
  if (typeof window !== "undefined") {
    const cookie = new Cookies();
    const cookies = cookie.get("user-mutui-history");
    if (cookies) {
      cookies.forEach((element) => {
        store.dispatch(FETCH_HISTORY(element));
      });
    }
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid") || cookie.get("gclid");
    let msmlid = params.get("msmlid") || cookie.get("msmlid");
    let utmsource = params.get("utm_source") || cookie.get("utm_source");
    let utmCampaign = params.get("utm_campaign") || cookie.get("utm_campaign");
    let utmchatbot = params.get("utm_chatbot") || cookie.get("utm_chatbot");
    let utmMedium = params.get("utm_medium") || cookie.get("utm_medium");
    let lastMethodLid = cookie.get("lastMethodLid");
    let msclkid = params.get("msclkid") || cookie.get("msclkid");

    if (params.get("utm_source")) {
      lastMethodLid = "utm_source";
    } else if (params.get("msmlid")) {
      lastMethodLid = "msmlid";
    }

    if (gclid) {
      store.dispatch(CONFIG_ADD_GCLID(gclid.trim()));
      cookie.set("gclid", gclid.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (msmlid) {
      store.dispatch(CONFIG_ADD_MSMLID(msmlid.trim()));
      cookie.set("msmlid", msmlid.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (utmchatbot) {
      store.dispatch(CONFIG_ADD_UTMCHATBOT(utmchatbot.trim()));
      cookie.set("utm_chatbot", utmchatbot.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (utmsource) {
      store.dispatch(CONFIG_ADD_UTMSOURCE(utmsource.trim()));
      cookie.set("utm_source", utmsource.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (lastMethodLid) {
      cookie.set("lastMethodLid", lastMethodLid, {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      }); //1 giorno
      store.dispatch(CONFIG_ADD_LAST_METHOD_LID(lastMethodLid));
    }

    if (utmCampaign) {
      store.dispatch(CONFIG_ADD_UTMCAMPAIGN(utmCampaign.trim()));
      cookie.set("utm_campaign", utmCampaign.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (utmMedium) {
      store.dispatch(CONFIG_ADD_UTMMEDIUM(utmMedium.trim()));
      cookie.set("utm_medium", utmMedium.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (msclkid) {
      store.dispatch(CONFIG_ADD_MSCLKID(msclkid.trim()));
      cookie.set("msclkid", msclkid.trim(), {
        path: "/",
        expires: new Date(Date.now() + 86400000),
      });
    }

    if (params?.size > 0) {
      const queryStringValues = {};
      for (const [key, value] of params.entries()) {
        queryStringValues[key] = value;
      }
      if (queryStringValues) {
        store.dispatch(CONFIG_ADD_QUERY_STRING_VALUES(queryStringValues));
      }
    }
    let gaClientID = cookie.get("_ga");
    if (gaClientID) {
      gaClientID = gaClientID.slice(6);
      store.dispatch(CHAT_MUTUO_SET_MESSAGES_CLIENT_ID(gaClientID));
    }
    const chatUID = cookie.get("chatmutuo-uid");
    if (chatUID) {
      store.dispatch(CHAT_MUTUO_SET_MESSAGES_UID(chatUID));
    }
    if (chatUID || gaClientID) {
      store.dispatch(
        CHAT_MUTUO_FETCH_HISTORY({
          uid: chatUID,
          clientId: gaClientID,
        })
      );
    }
  }
}

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    window.history.scrollRestoration = "manual";
    readChatNavPayload();
  }
  initialSetupConfigAppAsync();
};

const getStickyOffset = (fallback) => {
  let maxBottom = 0;
  document.querySelectorAll('header, [class*="navigatorAnchor"]').forEach(el => {
    const { position, display, visibility } = getComputedStyle(el);
    if (position !== "fixed" && position !== "sticky" && position !== "static") return;
    if (display === "none" || visibility === "hidden") return;
    const rect = el.getBoundingClientRect();
    if (rect.height <= 0) return;
    const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
    if (!isVisible) return;
    maxBottom = Math.max(maxBottom, rect.bottom);
  });

  if (maxBottom > 0) return maxBottom + 8;
  if (typeof fallback === "number") return fallback;
  // fallback legacy se non viene passato un override
  return window.innerWidth >= 768 ? 165 : 145;
};

// Altezza della barra NavigatorAnchor visibile e sticky/fixed (0 se assente).
// La barra mantiene altezza costante tra stato full e shrunk (cambia solo il top),
// quindi va sommata all'offset del navbar in entrambi gli stati.
const getNavigatorAnchorHeight = () => {
  let maxHeight = 0;
  document.querySelectorAll('[class*="navigatorAnchor"]').forEach((el) => {
    const { position, display, visibility } = getComputedStyle(el);
    if (position !== "fixed" && position !== "sticky") return; // esclude i bottoni (static)
    if (display === "none" || visibility === "hidden") return; // esclude la variante nascosta dal breakpoint
    const rect = el.getBoundingClientRect();
    if (rect.height <= 0) return;
    maxHeight = Math.max(maxHeight, rect.height);
  });
  return maxHeight;
};

export const onPreRouteUpdate = ({ location }) => {
  // Anti-flicker overlay su navigazione SPA: l'overlay è già nel DOM (setPreBodyComponents),
  // qui basta aggiungere la classe per renderlo visibile prima del rendering della nuova route.
  if (typeof document === "undefined") return;
  if (!new URLSearchParams(location.search).has("ChatBotAction")) return;
  document.documentElement.classList.add("anti-flicker-active");
  setTimeout(() => {
    document.documentElement.classList.remove("anti-flicker-active");
  }, 12000);
};

export const onRouteUpdate = ({ location }) => {
  // Anti-flicker overlay cleanup: rimuovi la classe quando arriviamo a /mutuo/ o /verifica/,
  // o appena l'URL non contiene più ChatBotAction (significa che la navigazione finale è avvenuta).
  if (typeof document !== "undefined") {
    const isFinalDestination = /^\/(mutuo|verifica)\//.test(location.pathname);
    const stillHasChatBotAction = new URLSearchParams(location.search).has("ChatBotAction");
    if (isFinalDestination || !stillHasChatBotAction) {
      document.documentElement.classList.remove("anti-flicker-active");
    }
  }

  if (!location.hash) return;

  const readVarPx = (name) => {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim();
    if (!raw) return 0;
    const n = parseFloat(raw);
    return Number.isFinite(n) && n > 0 ? n : 0;
  };

  // Stessa soglia di MenuDesktop (setShrunk quando scrollTop > 25).
  const SHRUNK_THRESHOLD = 25;
  // Sotto questa soglia, --header-offset-full vale solo il padding: l'header
  // è display:none (mobile/tablet) o assente (landing isLight).
  const HEADER_PRESENT_THRESHOLD = 20;

  const computeTargetTop = (el) => {
    const rect = el.getBoundingClientRect();
    const baseTop = rect.top + window.scrollY;

    const fullOffset =
      readVarPx("--header-offset-full") || readVarPx("--header-offset");
    const shrunkOffset = readVarPx("--header-offset-shrunk");
    // Su <992px il MenuDesktop è renderizzato ma non visibile in cima alla viewport,
    // quindi non va trattato come header fisso da compensare.
    const headerPresent =
      fullOffset > HEADER_PRESENT_THRESHOLD && window.innerWidth >= 992;
    // Barra ancore sticky (presente su page-flexible/post/rassegna a tutti i breakpoint).
    // Quando c'è, va compensata insieme al navbar anche su tablet/mobile.
    const anchorH = getNavigatorAnchorHeight();
    
    if (headerPresent || anchorH > 0) {
      // Predici l'altezza post-scroll del navbar (full vs shrunk) e somma la barra ancore.
      const preliminaryTarget = baseTop - (fullOffset + anchorH);
      const useShrunk = shrunkOffset > 0 && preliminaryTarget > SHRUNK_THRESHOLD;
      const navbarOffset = useShrunk ? shrunkOffset : fullOffset;
      return Math.max(0, baseTop - (navbarOffset + anchorH));
    }

    // Mobile/tablet/landing senza header fisso: appoggio alla fine del previousEl
    const previousEl = el.previousElementSibling;
    if (previousEl) {
      const previousRect = previousEl.getBoundingClientRect();
      return Math.max(0, previousRect.bottom + window.scrollY);
    }
    return Math.max(0, baseTop - getStickyOffset(0));
  };

  const scrollToAnchor = (el, attempt = 0) => {
    const targetTop = computeTargetTop(el);
    window.scrollTo({ top: targetTop, behavior: "auto" });

    // Stabilization loop: dopo eventuali layout shift (img/thumbnail lazy-loaded)
    // ricomputa e ri-scrolla se il target è cambiato di > 5px.
    if (attempt < 3) {
      const delay = [100, 200, 400][attempt];
      setTimeout(() => {
        const newTarget = computeTargetTop(el);
        if (Math.abs(newTarget - window.scrollY) > 5) {
          scrollToAnchor(el, attempt + 1);
        }
      }, delay);
    }
  };

  const scrollToHash = (attempts = 0) => {
    const el = document.querySelector(location.hash);
    if (el && el.offsetTop > 0) {
      scrollToAnchor(el);
      return;
    }
    if (attempts < 25) {
      setTimeout(() => scrollToHash(attempts + 1), 100);
    } else if (el) {
      scrollToAnchor(el);
    }
  };

  setTimeout(() => scrollToHash(), 200);
};

function InitialSetupConfigApp({ children }) {
  const {
    chatMutuo: {
      wizard: { abilita },
    },
  } = useStaticQueryDataChatMutuo();

  const {
    messages: { data },
  } = useSelector(getChatMutuo);

  useEffect(() => {
    const cookie = new Cookies();
    const savedMessage = cookie.get("latest-cms-message");
    store.dispatch(CHAT_MUTUO_IS_LAST_LINK_MESSAGES_VISIBILE(true));

    if (savedMessage !== undefined) {
      store.dispatch(CHAT_MUTUO_LATEST_CMS_MESSAGE(savedMessage));
    }

    store.dispatch(CHAT_MUTUO_IS_WIZARD_VISIBLE(abilita ? true : false));
    if (data.length > 0) {
      store.dispatch(CHAT_MUTUO_IS_ACTIVE_LAST_CMS_MESSAGE(true));
      store.dispatch(CHAT_MUTUO_IS_WIZARD_VISIBLE(false));
      store.dispatch(CHAT_MUTUO_HIDE_OLD_QUESTIONS());
      // store.dispatch(CHAT_MUTUO_IS_LAST_LINK_MESSAGES_VISIBILE(true));
      const lastMessage = data[data.length - 1];
      if (
        !savedMessage &&
        lastMessage.Sender === "cms" &&
        lastMessage.Data?.elementi
      ) {
        store.dispatch(
          CHAT_MUTUO_LATEST_CMS_MESSAGE(lastMessage.Data.elementi)
        );
        cookie.set("latest-cms-message", lastMessage.Data.elementi, {
          path: "/",
          expires: new Date(Date.now() + 86400000), // 1 día
        });
      }
    }
  }, []);
  return <>{children}</>;
}

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      <WebMcpTools />
      <InitialSetupConfigApp>{element}</InitialSetupConfigApp>
    </Provider>
  );
};

export const wrapPageElement = ({ element, props }) => {
  const { data } = props;
  if (element?.key?.includes("404.html")) {
    return element;
  }
  if (props.location.pathname.startsWith("/app/")) {
    return element;
  }
  else if(data?.wpPage?.template?.templateName === "Landing Page"){
    return <LayoutLandingPage {...props}>{element}</LayoutLandingPage>;
  }
  const {
    pageContext: { isWidget = false },
  } = props;
  if (isWidget) {
    return <main className="__iframe">{element}</main>;
  } else {
    return <Layout {...props}>{element}</Layout>;
  }
};

export const replaceHydrateFunction = () => {
  return (element, container) => {
    createRoot(container).render(element);
  };
};

export const shouldUpdateScroll = ({
  routerProps: { location: currentLocation = "" },
  prevRouterProps,
  getSavedScrollPosition,
}) => {
  //console.clear();
  window.history.scrollRestoration = "manual";

  // FIX #4 — Ripristino scroll al ritorno dalla ChatMutuo (page o widget→/mutuo/)
  {
    const prevPath = prevRouterProps?.location?.pathname || "";
    const curPath = currentLocation.pathname || "";
    const isReturnFromChat = /^\/(chatmutuo|chiedi-a-chatmutuo-ai)\/?$/.test(prevPath);
    const isReturnFromMutuo = /^\/(mutuo|verifica)\//.test(prevPath);

    if (isReturnFromChat || isReturnFromMutuo) {
      const payload = readChatNavPayload();
      const sameOrigin =
        payload &&
        (payload.fromPath === curPath ||
          payload.fromPath + "/" === curPath ||
          payload.fromPath === curPath + "/");
      if (sameOrigin) {
        clearChatNavPayload();
        if (payload.widgetWasOpen) {
          store.dispatch(CHAT_MUTUO_SHOW());
          store.dispatch(CHAT_MUTUO_SHOW_CHAT());
        }
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo({
              top: payload.scrollY,
              left: 0,
              behavior: "auto",
            });
          });
        });
        return false;
      }
    }
  }

  const currentPosition = getSavedScrollPosition(
    currentLocation,
    currentLocation.key
  );

  // FAKE MODAL (VERIFICA || MUTUO) === INSTANT SCROLL
  const { pathname: prevPathname = "" } = prevRouterProps?.location || {};
  const prevIsFakeModal = new RegExp(/\/verifica\/|\/mutuo\//);
  const isFromModalMutuoOrVerifica = prevPathname.match(prevIsFakeModal);

  if (isFromModalMutuoOrVerifica) {
    document.documentElement.style.scrollBehavior = "auto";
  }

  // GLOSSARIO
  const glossarioRegex = new RegExp(/^\/glossario-mutui\/$/);
  if (currentLocation.pathname.match(glossarioRegex)) {
    return false;
  }
  // HOMEPAGE, SURROGA, ACQUISTO PRIMA CASA
  const homepageRegex = new RegExp(/^\/$/);

  if (currentLocation.pathname.match(homepageRegex) && !isFromModalMutuoOrVerifica) {
    if (prevPathname === currentLocation.pathname) {
      return false; // navigazione intra-pagina (solo query cambia), preserva scroll
    }
    window.scrollTo(0, 0);
    return false;
  }

  
  // Deep-link a un grafico (`?indice=N`): NON scrollare in cima. L'hash viene aggiunto
  // dal componente Grafico e onRouteUpdate porta direttamente al grafico: evitiamo così
  // il doppio salto (prima in cima, poi verso il grafico).
  const isChartDeepLink = new URLSearchParams(
    currentLocation.search || ""
  ).has("indice");

  if (!currentPosition) {
    if (!currentLocation.hash && !isChartDeepLink) {
      window.scrollTo(0, 0);
    }
    // hash o deep-link ?indice: scroll gestito da onRouteUpdate
    return false;
  }

  const [x, y] = currentPosition;

  // Se la posizione è [0, 0] e siamo già in alto, non fare nulla
  if (x === 0 && y === 0) {
    setTimeout(() => {
      requestAnimationFrame(() => {
        if (
          window.scrollY > 0 &&
          !isFromModalMutuoOrVerifica &&
          !currentLocation.hash &&
          !isChartDeepLink
        ) {
          window.scrollTo(0, 0);
        }
      });
    }, 100);
    return false;
  }

  // Scroll alla posizione salvata
  setTimeout(() => {
    requestAnimationFrame(() => {
      window.scrollTo(x, y);
    });
  }, 100);
};
